<template>
  <div class="mt-3">
    <div class="flex flex-col gap-1">
      <h6 class="mb-0">Late Fees</h6>
      <hr />
      <ToggleSwitch
        v-model="department.late_fees_enabled"
        label-on="Enable Late Fees"
      />
    </div>
    <div
      v-show="!department.late_fees_enabled"
      class="fees-disabled-notice mt-2 ml-2"
    >
      If late fees are disabled they will not be able to be enabled again.
    </div>
    <div class="mt-3 mb-2 flex">
      <TextField
        v-model="department.late_fee_per_minute_cents"
        currency
        label="Late Fee (per minute)"
        name="late_fee_per_minute_cents"
        placeholder="$0.0"
        :validation-errors="v$.$errors"
        labelClass="half-row"
      />
      <TextField
        v-model="department.max_late_fee_cents"
        currency
        label="Maximum Late Fee"
        name="max_late_fee_cents"
        placeholder="$0.0"
        :validation-errors="v$.$errors"
        labelClass="half-row ml-4"
      />
    </div>
    <SelectBox
      v-if="legacyDiscountBatchingEnabled && showAccountingCategories"
      v-model="department.late_fee_accounting_category_id"
      name="Accounting Category"
      placeholder="Accounting Category"
      label="Late Fee Accounting Category"
      :options="accountingCategoriesOptions"
      class="half-width mr-3"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import SelectBox from "@/components/SelectBox.vue";
import TextField from "@/components/TextField.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  components: {
    TextField,
    ToggleSwitch,
    SelectBox
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      department: {}
    };
  },
  computed: {
    ...mapGetters(["showAccountingCategories"]),
    ...mapState({
      currentDepartment: "currentDepartment",
      accountingCategories: "accountingCategories",
      accountingCategoriesOptions: ({ accountingCategories }) =>
        accountingCategories.map((accountingCategory) => ({
          value: accountingCategory.id,
          label: accountingCategory.name
        })),
      legacyDiscountBatchingEnabled({ tenant }) {
        return tenant?.legacy_discount_batching;
      }
    })
  },
  watch: {
    currentDepartment(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        const {
          late_fees_enabled,
          late_fee_per_minute_cents,
          max_late_fee_cents,
          late_fee_accounting_category_id
        } = { ...this.currentDepartment };
        this.department = {
          late_fees_enabled,
          late_fee_per_minute_cents,
          max_late_fee_cents,
          late_fee_accounting_category_id
        };
      }
    }
  },
  validations() {
    return {
      department: {
        late_fee_per_minute_cents: { required, $autoDirty: true },
        max_late_fee_cents: { required, $autoDirty: true }
      }
    };
  },
  methods: {
    getDataToSave() {
      return this.v$.$validate().then((valid) => {
        if (!valid)
          return Promise.reject(new Error("Late Fee fields validation failed"));
        return this.department;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.half-width {
  width: 48% !important;
}
.fees-disabled-notice {
  color: var(--red);
}
</style>
